import { FeatureNames } from '@swyft/ui';
import { useAppContext } from './appState';

export const useFeature = (featureName: FeatureNames) => {
  const {
    state: { features }
  } = useAppContext();
  const feature = features.find((f) => f.name === featureName);
  if (!feature) {
    return {
      enabled: false,
      featureConfig: null
    };
  }
  const { enabled, featureConfig } = feature;
  return { enabled, featureConfig };
};
